module.exports = __webpack_public_path__ + "static/media/task.1cde38ed.svg";